import React,{useEffect} from 'react'
import {useNavigate} from 'react-router-dom'
const Nri = () => {
    const navigate = useNavigate()
    useEffect(()=>{
       setTimeout(()=>{
        alert('Applications for NRI / Foreign Applicants will open soon. ')
        navigate('/')
       },2000)
    })
  return (
    <>

    </>
  )
}

export default Nri